import React, { createContext, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';







const EMPTY_TIMINGS = [];



const normalise = word => word.toLowerCase().replace(/[’‘]/g, "'").replace(/[^\p{L}\p{N}']/gu, '');







// Keep measured speech cues; estimate only script tokens absent from the ASR.



function buildTimeline(narration, wordTimings, duration) {



  const script = narration.match(/\S+/g) || [];



  const spoken = (Array.isArray(wordTimings) ? wordTimings : []).filter(item =>



    item && typeof item.word === 'string' && Number.isFinite(item.start) && Number.isFinite(item.end) && item.start >= 0 && item.end >= item.start);



  const length = duration > 0 ? duration : spoken.length ? spoken[spoken.length - 1].end : script.length / 2.5;



  const mapped = Array(script.length).fill(null);



  if (spoken.length) {



    const rows = script.length + 1, columns = spoken.length + 1;



    const scores = new Uint16Array(rows * columns);



    const source = script.map(normalise), audio = spoken.map(item => normalise(item.word));



    for (let i = 1; i < rows; i += 1) for (let j = 1; j < columns; j += 1) {



      scores[i * columns + j] = source[i - 1] && source[i - 1] === audio[j - 1]



        ? scores[(i - 1) * columns + j - 1] + 1



        : Math.max(scores[(i - 1) * columns + j], scores[i * columns + j - 1]);



    }



    let i = script.length, j = spoken.length;



    while (i > 0 && j > 0) {



      if (source[i - 1] && source[i - 1] === audio[j - 1]) {



        mapped[i - 1] = { ...spoken[j - 1], measured: true }; i -= 1; j -= 1;



      } else if (scores[(i - 1) * columns + j] >= scores[i * columns + j - 1]) i -= 1;



      else j -= 1;



    }



  }



  const measured = mapped.filter(Boolean).length;



  for (let index = 0; index < mapped.length;) {



    if (mapped[index]) { index += 1; continue; }



    const from = index;



    while (index < mapped.length && !mapped[index]) index += 1;



    const start = from ? mapped[from - 1].end : 0;



    const end = Math.max(start, index < mapped.length ? mapped[index].start : length);



    const span = (end - start) / (index - from);



    for (let k = from; k < index; k += 1) mapped[k] = {



      start: start + (k - from) * span, end: start + (k - from + 1) * span, measured: false,



    };



  }



  return { words: mapped, mode: measured === script.length ? 'measured' : measured ? 'mixed' : 'estimated' };



}







function wordOffset(narration, phrase) {



  const at = narration.indexOf(phrase);



  if (at < 0) throw new Error(`Missing narration cue: ${phrase}`);



  return narration.slice(0, at).trim().split(/\s+/).filter(Boolean).length;



}



function cueTime(narration, timeline, phrase) {



  return timeline.words[wordOffset(narration, phrase)]?.start ?? Infinity;



}



function buildBeats(narration, timeline, phrases, endPhrase) {



  const script = narration.match(/\S+/g) || [];



  const offsets = phrases.map(phrase => wordOffset(narration, phrase));



  const end = endPhrase ? wordOffset(narration, endPhrase) : script.length;



  return offsets.map((from, index) => ({



    start: timeline.words[from]?.start ?? Infinity,



    text: script.slice(from, offsets[index + 1] ?? end).join(' '),



    timings: timeline.words.slice(from, offsets[index + 1] ?? end).map(word => word.start),



  }));



}



function activeIndex(items, now) {



  let index = 0;



  items.forEach((item, i) => { if (now >= item.start) index = i; });



  return index;



}







// Read the audio clock each frame, but render only when a word boundary,



// pause, seek or playback rate changes. Native CSS handles the motion.



function useLessonClock({ time = 0, audioElement, audioRef, playbackId, audioStatus } = {}, timeline) {



  const boundaries = useMemo(() => timeline.words.map(word => word.start), [timeline]);



  const sourceTime = Number.isFinite(time) ? Math.max(0, time) : 0;



  const parentAnchor = useRef({ time: sourceTime, stamp: null });



  const controller = useRef({ time: sourceTime, boundary: -2, playing: false, rate: 1, syncId: 0 });



  const [clock, setClock] = useState({ now: sourceTime, playing: audioStatus === 'Playing', rate: 1, syncId: 0, seeking: false });



  const boundaryAt = current => {



    let low = 0, high = boundaries.length;



    while (low < high) {



      const middle = (low + high) >>> 1;



      if (boundaries[middle] <= current + .005) low = middle + 1;



      else high = middle;



    }



    return low - 1;



  };



  useEffect(() => {



    const previous = parentAnchor.current;



    const stamp = performance.now();



    const elapsed = previous.stamp == null ? 0 : (stamp - previous.stamp) / 1000;



    const expected = previous.time + (controller.current.playing ? elapsed * controller.current.rate : 0);



    const seek = previous.stamp != null && Math.abs(sourceTime - expected) > .6;



    parentAnchor.current = { time: sourceTime, stamp };



    // The media element is authoritative when available; otherwise changes to



    // the parent's time keep the interpolated fallback clock anchored.



    if (!(audioElement ?? audioRef?.current) && seek) {



      controller.current.syncId += 1;



      controller.current.boundary = -2;



      controller.current.time = sourceTime;



      setClock({ now: sourceTime, playing: audioStatus === 'Playing', rate: 1,



        syncId: controller.current.syncId, seeking: true });



    }



  }, [sourceTime, audioElement, audioRef]);



  useEffect(() => {



    const media = audioElement ?? audioRef?.current;



    let frame;



    const read = () => {



      const state = controller.current;



      const playing = media ? !media.paused && !media.ended : audioStatus === 'Playing';



      const rate = media ? media.playbackRate || 1 : 1;



      const anchor = parentAnchor.current;



      const current = media ? Math.max(0, media.currentTime || 0) : Math.max(0,



        anchor.time + (playing && anchor.stamp != null ? (performance.now() - anchor.stamp) / 1000 * rate : 0));



      const boundary = boundaryAt(current);



      return { current, boundary, playing, rate };



    };



    const update = (force = false, seek = false) => {



      const sample = read(), state = controller.current;



      const rateChanged = sample.rate !== state.rate;



      if (seek || rateChanged) state.syncId += 1;



      state.time = sample.current;



      if (force || seek || rateChanged || sample.boundary !== state.boundary || sample.playing !== state.playing) {



        state.boundary = sample.boundary;



        state.playing = sample.playing;



        state.rate = sample.rate;



        setClock({ now: sample.current, playing: sample.playing, rate: sample.rate,



          syncId: state.syncId, seeking: seek || rateChanged });



      }



      return sample.playing;



    };



    const tick = () => { if (update()) frame = requestAnimationFrame(tick); };



    const play = () => { cancelAnimationFrame(frame); update(true); frame = requestAnimationFrame(tick); };



    const stop = () => { cancelAnimationFrame(frame); update(true); };



    const seek = () => { update(true, true); };



    const rate = () => { update(true); };



    const sync = () => { update(); };



    if (media) {



      media.addEventListener('play', play); media.addEventListener('pause', stop);



      media.addEventListener('ended', stop); media.addEventListener('seeked', seek);



      media.addEventListener('ratechange', rate); media.addEventListener('timeupdate', sync);



    }



    controller.current.syncId += 1;



    update(true);



    if (read().playing) frame = requestAnimationFrame(tick);



    return () => {



      cancelAnimationFrame(frame);



      if (media) {



        media.removeEventListener('play', play); media.removeEventListener('pause', stop);



        media.removeEventListener('ended', stop); media.removeEventListener('seeked', seek);



        media.removeEventListener('ratechange', rate); media.removeEventListener('timeupdate', sync);



      }



    };



  }, [audioElement, audioRef, playbackId, audioStatus, boundaries]);



  return clock;



}







const MotionClock = createContext({ playing: true, rate: 1, syncId: 0 });



function MotionScope({ clock, children }) {



  const value = useMemo(() => ({ playing: clock.playing, rate: clock.rate, syncId: clock.syncId }),



    [clock.playing, clock.rate, clock.syncId]);



  return <MotionClock.Provider value={value}>{children}</MotionClock.Provider>;



}







// Freeze delays at mount/cue/seek. Do not change animationDelay on every



// clock update: CSS runs the 380ms rise/fade smoothly between React renders.



function RevealText({ as: Element = 'span', text = '', segments, timings, start = 0, now = 0,



  delay = 0, complete = false, className = '' }) {



  const { playing, rate, syncId } = useContext(MotionClock);



  const pieces = segments || [{ text }];



  const ariaText = pieces.map(piece => piece.text).join(' ');



  const timingKey = timings?.join(',') ?? '';



  const origin = useMemo(() => now, [syncId, start, delay, complete, ariaText, timingKey, rate]);



  let wordIndex = 0;



  return <Element className={className} aria-label={ariaText}>



    {pieces.map((piece, pieceIndex) => <React.Fragment key={pieceIndex}>



      {pieceIndex > 0 ? ' ' : ''}



      <span className={piece.handwritten ? `training-handwritten ${piece.long ? 'is-long' : ''}` : 'training-plain'}>



        {piece.text.split(/\s+/).filter(Boolean).map((word, index, words) => {



          const indexInPhrase = wordIndex++;



          const revealAt = timings?.[indexInPhrase] ?? start + delay + indexInPhrase * .09;



          return <React.Fragment key={index}>



            <span key={syncId} className="training-reveal-word" aria-hidden="true" style={{



              animationDelay: `${complete ? -10 : (revealAt - origin) / rate}s`,



              animationDuration: `${.38 / rate}s`,



              animationPlayState: playing ? 'running' : 'paused',



            }}>{word}</span>{index < words.length - 1 ? ' ' : ''}



          </React.Fragment>;



        })}



      </span>



    </React.Fragment>)}



  </Element>;



}







// Phrase changes overlap briefly, without blurring the entire slide.



function SceneTransition({ sceneKey, start = 0, now, instant = false, children }) {



  const { playing, rate, syncId } = useContext(MotionClock);



  const origin = useMemo(() => now, [sceneKey, start, syncId, rate]);



  const previous = useRef({ key: sceneKey, syncId, children });



  const [outgoing, setOutgoing] = useState(null);



  useLayoutEffect(() => {



    const old = previous.current;



    const changed = old.key !== sceneKey;



    previous.current = { key: sceneKey, syncId, children };



    if (instant || old.syncId !== syncId) { setOutgoing(null); return undefined; }



    if (!changed) return undefined;



    setOutgoing(old);



    const timer = window.setTimeout(() => setOutgoing(null), 450 / rate);



    return () => window.clearTimeout(timer);



  }, [sceneKey, instant, syncId, rate]);



  useLayoutEffect(() => { previous.current.children = children; });



  return <div className="training-transition-shell">



    {outgoing && !instant && <div key={`out-${outgoing.key}`} className="training-scene-layer is-exiting" aria-hidden="true">{outgoing.children}</div>}



    <div key={`in-${sceneKey}-${syncId}`} className="training-scene-layer is-entering" style={{



      animationDelay: `${instant ? -10 : (start - origin) / rate}s`,



      animationDuration: `${.45 / rate}s`, animationPlayState: playing ? 'running' : 'paused',



    }}>{children}</div>



  </div>;



}







const REVEAL_STYLES = `



.training-plain {display:inline;}



.training-reveal-word {display:inline-block;opacity:0;transform:translateY(.36em);animation:training-word-in 380ms cubic-bezier(.18,.84,.22,1) both;}



.training-handwritten {display:inline-block;font-family:'Ugly Handwriting',cursive;font-size:1.12em;font-weight:400;letter-spacing:-.012em;line-height:.9;}



.training-handwritten.is-long {display:block;width:fit-content;max-width:100%;margin:.12em auto 0;}



.training-transition-shell {position:absolute;inset:0;overflow:hidden;}



.training-scene-layer {position:absolute;inset:0;}



.training-scene-layer.is-entering {z-index:2;animation:training-scene-enter 450ms cubic-bezier(.16,1,.3,1) both;}



.training-scene-layer.is-exiting {z-index:1;pointer-events:none;animation:training-scene-exit 450ms cubic-bezier(.4,0,.2,1) both;}



@keyframes training-word-in {to {opacity:1;transform:translateY(0);}}



@keyframes training-scene-enter {from {opacity:0;transform:translate3d(20px,10px,0);}to {opacity:1;transform:translate3d(0,0,0);}}



@keyframes training-scene-exit {from {opacity:1;transform:translate3d(0,0,0);}to {opacity:0;transform:translate3d(-18px,-8px,0);}}



.is-seeking .training-scene-layer.is-exiting {display:none;}



@media(prefers-reduced-motion:reduce){



 .training-reveal-word {animation:none;opacity:1;transform:none;}



 .training-scene-layer {animation:none!important;opacity:1;transform:none;filter:none;}



 .training-scene-layer.is-exiting {display:none;}



}



`;











const ROLE_COLUMNS = [

  { id: 'flow', title: 'Manage the event flow', cue: 'The first responsibility', rows: [

    { title: 'Follow the guide', description: 'Use the agenda and instructions provided for your event.', cue: 'it’s your job to follow' },

    { title: 'Own the flow', description: 'Take charge of how it runs, adjusting when needed to keep things moving.', cue: 'and take ownership' },

  ] },

  { id: 'connection', title: 'Help guests connect', cue: 'Your second responsibility', rows: [

    { title: 'Be friendly', description: 'Welcome guests warmly and introduce them to one another.', cue: 'Being friendly' },

    { title: 'Create comfort', description: 'Bring a fun, approachable energy so people can relax and get to know each other.', cue: 'helps guests feel comfortable' },

  ] },

];



function PointIcon({ index }) {

  return <svg className="role-point-icon" width="26" height="26" viewBox="0 0 24 24"

    fill="none" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">

    {index === 0 ? <><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 8h6M9 12h6M9 16h4" /></> :

      index === 1 ? <><path d="M4 6h13a3 3 0 0 1 0 6H7a3 3 0 0 0 0 6h13M16 15l4 3-4 3" /><circle cx="4" cy="6" r="1.5" /></> :

      index === 2 ? <><circle cx="8" cy="7" r="3" /><path d="M2 20v-2a6 6 0 0 1 12 0v2M16 4a3 3 0 0 1 0 6M22 20v-2a6 6 0 0 0-5-6" /></> :

      <><circle cx="12" cy="12" r="9" /><path d="M8 14a4.5 4.5 0 0 0 8 0M8.5 9h.01M15.5 9h.01" /></>}

  </svg>;

}



function YourRoleScene(props) {



  const { duration = 0, wordTimings = EMPTY_TIMINGS, audioStatus } = props;



  const narration = YourRole.parts[0].narration;



  const timeline = useMemo(() => buildTimeline(narration, wordTimings, duration), [narration, wordTimings, duration]);



  const cues = useMemo(() => ({



    dock: cueTime(narration, timeline, 'two main responsibilities'),



    finish: timeline.words.at(-1)?.end ?? Infinity,



    columns: ROLE_COLUMNS.map(column => ({ ...column,



      start: cueTime(narration, timeline, column.cue),



      rows: column.rows.map(row => ({ ...row, start: cueTime(narration, timeline, row.cue) })),



    })),



  }), [narration, timeline]);



  const clock = useLessonClock(props, timeline);



  const { now, seeking } = clock;



  const finished = audioStatus === 'Complete' || now >= cues.finish;



  const open = finished || now >= cues.dock;



  const focusedColumn = finished ? -1 : now >= cues.columns[1].start ? 1 : 0;



  return <MotionScope clock={clock}><section className={`role-kinetic-slide ${open ? 'is-open' : ''} ${finished ? 'is-reviewing' : ''} ${seeking ? 'is-seeking' : ''}`}



    data-timing-mode={timeline.mode} data-focus={finished ? 'both' : focusedColumn === 0 ? 'left' : 'right'}>



    <RevealText as="h1" className="role-heading" text="Your role as a host" now={now}



      timings={timeline.words.slice(0, 5).map(word => word.start)} complete={finished} />



    <div className="role-table role-editorial-grid" aria-label="Two host responsibilities" aria-hidden={!open}>

      {cues.columns.map((column, columnIndex) => {

        let focusedRow = -1;

        column.rows.forEach((item, index) => { if (now >= item.start) focusedRow = index; });

        return <section className="role-responsibility" key={column.id} aria-label={column.title}>

          <header className={`role-column-heading ${!finished && focusedColumn !== columnIndex ? 'is-muted' : ''}`}>

            <span className="role-group-number" aria-hidden="true">{String(columnIndex + 1).padStart(2, '0')}</span>

            <RevealText as="h2" text={column.title} start={column.start} now={now} complete={finished} />

          </header>

          <div className="role-points">

            {column.rows.map((row, rowIndex) => {

              const visible = finished || now >= row.start;

              const current = !finished && focusedColumn === columnIndex && focusedRow === rowIndex;

              return <div key={row.cue}

                className={`role-point ${visible ? 'is-visible' : ''} ${current ? 'is-current' : ''}`}>

                <div className="role-point-marker" aria-hidden="true">

                  <span className="role-point-number">

                    <span className="role-point-digit">{columnIndex * 2 + rowIndex + 1}</span>

                    <PointIcon index={columnIndex * 2 + rowIndex} />

                  </span>

                  <span className="role-point-stem" />

                  <span className="role-point-dot" />

                </div>

                <div className="role-point-copy" aria-hidden={!visible}>

                  <RevealText as="h3" text={row.title} start={row.start} now={now} complete={finished} />

                  <RevealText as="p" text={row.description} start={row.start} now={now}

                    delay={.24} complete={finished} />

                </div>

              </div>;

            })}

          </div>

        </section>;

      })}

    </div>



  </section></MotionScope>;



}







export default function YourRole(props = {}) {



  return <div className="host-background-slide host-role-slide" aria-label={YourRole.title}>



    <style>{HEADLINE_FONT_IMPORT + REVEAL_STYLES + ROLE_STYLES + DESIGN_STYLES + HEADLINE_FONT_STYLES + EDITORIAL_STYLES}</style><YourRoleScene {...props} />



  </div>;



}







const ROLE_STYLES = `



.host-role-slide {width:100%;background:#fff;color:#111;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;-webkit-font-smoothing:antialiased;}



.host-role-slide * {box-sizing:border-box;}



.host-role-slide .role-kinetic-slide {position:relative;width:100%;min-height:530px;overflow:hidden;background:#fff;}



.host-role-slide .role-heading {position:absolute;top:50%;left:50%;z-index:2;width:calc(100% - 64px);max-width:1080px;margin:0;font-family:inherit;font-size:clamp(38px,5.4vw,70px);font-weight:750;line-height:1.1;letter-spacing:-.04em;text-align:center;transform:translate(-50%,-50%);transition:top 650ms cubic-bezier(.16,1,.3,1),transform 650ms cubic-bezier(.16,1,.3,1),font-size 650ms cubic-bezier(.16,1,.3,1);}



.host-role-slide .is-open .role-heading {top:32px;font-size:clamp(29px,3.25vw,43px);transform:translate(-50%,0);}



.host-role-slide .role-table {position:relative;width:calc(100% - 96px);max-width:1040px;margin:132px auto 42px;opacity:0;visibility:hidden;transform:translateY(18px);transition:opacity 420ms ease,transform 550ms cubic-bezier(.16,1,.3,1),visibility 0ms 550ms;}



.host-role-slide .is-open .role-table {opacity:1;visibility:visible;transform:translateY(0);transition:opacity 420ms 180ms ease,transform 550ms 180ms cubic-bezier(.16,1,.3,1),visibility 0ms;}



.host-role-slide .role-table-head,.host-role-slide .role-table-row {display:grid;grid-template-columns:repeat(2,minmax(0,1fr));}



.host-role-slide .role-column-heading {position:relative;display:flex;align-items:center;gap:16px;padding:14px 32px 24px;opacity:1;transition:opacity 380ms ease;}



.host-role-slide .role-column-heading::after {position:absolute;left:32px;right:32px;bottom:0;height:1px;background:#dedede;content:'';}



.host-role-slide .role-column-heading:first-child,.host-role-slide .role-table-cell:first-child {border-right:1px solid #dedede;}



.host-role-slide .role-column-heading h2 {min-width:0;margin:0;font-family:inherit;font-size:clamp(19px,1.9vw,23px);font-weight:650;line-height:1.25;letter-spacing:-.022em;}



.host-role-slide .role-column-number {display:grid;place-items:center;flex:0 0 30px;height:30px;border:1px solid #d8d8d8;border-radius:50%;color:#111;background:#fff;font-family:inherit;font-size:12px;font-weight:500;line-height:1;font-variant-numeric:tabular-nums;}



.host-role-slide .role-column-heading.is-muted {opacity:.3;}



.host-role-slide .role-table-body {padding-top:12px;}



.host-role-slide .role-table-cell {min-width:0;min-height:82px;padding:24px 32px;opacity:0;visibility:hidden;transition:opacity 380ms ease;}



.host-role-slide .role-table-cell p {margin:0;font-family:inherit;font-size:clamp(21px,2vw,26px);font-weight:450;line-height:1.35;letter-spacing:-.022em;}



.host-role-slide .role-table-cell strong {font-weight:650;}



.host-role-slide .role-table-cell.is-visible {visibility:visible;opacity:.56;}



.host-role-slide .role-table-cell.is-visible.is-muted {opacity:.3;}



.host-role-slide .role-table-cell.is-current {opacity:1;}



.host-role-slide .is-reviewing .role-column-heading,.host-role-slide .is-reviewing .role-table-cell.is-visible {opacity:1;}



.host-training .ht-lesson-layout:has(.host-role-slide) {display:block;padding:0;}



.host-training .ht-lesson-layout:has(.host-role-slide)>.ht-lesson-copy {display:none;}



.host-training .ht-lesson-visual:has(.host-role-slide) {display:block;padding:0;background:#fff;border:0;border-radius:0;}



@media(max-width:760px){



 .host-role-slide .role-kinetic-slide {min-height:540px;}



 .host-role-slide .role-heading {width:calc(100% - 40px);font-size:clamp(32px,8.4vw,46px);}



 .host-role-slide .is-open .role-heading {top:28px;font-size:clamp(27px,6.6vw,36px);}



 .host-role-slide .role-table {width:calc(100% - 36px);margin-top:116px;margin-bottom:34px;}



 .host-role-slide .role-column-heading {align-items:flex-start;gap:10px;padding:14px 14px 20px;}



 .host-role-slide .role-column-heading::after {left:14px;right:14px;}



 .host-role-slide .role-column-number {flex-basis:27px;height:27px;font-size:11px;}



 .host-role-slide .role-column-heading h2 {font-size:clamp(17px,4.3vw,23px);line-height:1.25;letter-spacing:-.02em;}



 .host-role-slide .role-table-cell {min-height:86px;padding:22px 14px;}



 .host-role-slide .role-table-cell p {font-size:clamp(17px,4.2vw,22px);line-height:1.4;letter-spacing:-.015em;}



}



@media(max-width:360px){



 .host-role-slide .role-table {width:calc(100% - 24px);}



 .host-role-slide .role-column-heading,.host-role-slide .role-table-cell {padding-right:10px;padding-left:10px;}



 .host-role-slide .role-column-heading::after {left:10px;right:10px;}



 .host-role-slide .role-column-heading {gap:8px;}



 .host-role-slide .role-column-heading h2,.host-role-slide .role-table-cell p {font-size:16px;}



}



@media(prefers-reduced-motion:reduce){.host-role-slide .role-heading,.host-role-slide .role-table,.host-role-slide .role-table-cell,.host-role-slide .role-column-heading {transition:none;}}



.host-role-slide .is-seeking .role-heading,.host-role-slide .is-seeking .role-table,.host-role-slide .is-seeking .role-table-cell {transition:none;}



`;



Object.assign(YourRole, {



  slide: 4, id: 'your-role', title: 'Your Role as a Host', section: 'Background',



  parts: [{ part: 0, narration: "Your role as a host comes down to two main responsibilities.\nThe first responsibility is managing the event flow. While we’ll provide clear instructions for your assigned event, it’s your job to follow the guide and take ownership of how it runs. If there’s a hiccup, we expect you to use your judgment to adjust and keep things moving.\nYour second responsibility is helping guests connect. As the host, you act as the glue of the group. Being friendly, making introductions, and being fun to be around helps guests feel comfortable and start getting to know each other." }],



  summary: ['Manage the event flow.', 'Be the glue of the group.'],



  check: {



    prompt: 'The event plan changes unexpectedly. What is your role?',



    choices: ['Wait for guests to decide what happens next.', 'Use your judgment to adjust and keep the experience moving.', 'End the event immediately.'],



    correct: 1, explanation: 'Tribe provides the plan, and you take ownership of how it runs. Keep guests informed as you adjust.',



  },



});







const DESIGN_STYLES = `



.welcome-simple,.host-event-structure,.host-tribe-slide,.host-role-slide {



 --training-heading-size:clamp(29px,3.25vw,43px);



 --training-hero-size:clamp(38px,5.4vw,70px);



 font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;



 -webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;



}



.welcome-simple .welcome-simple-roadmap {max-width:1040px;padding-top:36px;}



.welcome-simple .welcome-simple-roadmap h1 {text-align:center;font-size:clamp(24px,2.55vw,32px);margin-bottom:72px;}



.welcome-simple .welcome-simple-caption,.host-event-structure .event-flow-opening-copy,.definition-caption h1,.tribe-concept-intro h1,.host-role-slide .role-heading {



 max-width:850px;font-size:clamp(32px,4vw,50px);line-height:1.12;letter-spacing:-.035em;



}



.welcome-simple .welcome-simple-number {width:26px;height:26px;font-size:11px;font-weight:500;font-variant-numeric:tabular-nums;}



.welcome-simple .welcome-simple-grid h2,.difference-field-item h2,.host-role-slide .role-column-heading h2 {font-size:clamp(18px,1.7vw,21px);line-height:1.3;}



.welcome-simple .welcome-simple-grid p,.difference-field-item p {font-size:clamp(13px,1.15vw,15px);line-height:1.55;}



.difference-field-title,.host-event-structure .event-flow-heading,.host-role-slide .is-open .role-heading {font-size:clamp(24px,2.55vw,32px);line-height:1.15;}



.difference-field {padding-top:36px;}



.difference-field-items {max-width:1040px;margin-top:80px;}



.difference-number,.host-role-slide .role-column-number {width:26px;height:26px;font-size:11px;}



.host-role-slide .role-column-number {flex-basis:26px;}



.host-role-slide .role-table {max-width:960px;}



.host-role-slide .role-table-cell p {font-size:clamp(18px,1.7vw,22px);}



.definition-review h1 {max-width:780px;font-size:clamp(27px,3vw,38px);}



.host-event-structure .event-flow-scene {min-height:530px;}



.host-event-structure .event-flow-heading {top:36px;}



.host-event-structure .journey-diagrams {max-width:1120px;margin-top:136px;}



.host-event-structure .journey-stage-label {font-size:21px;font-weight:650;}



.host-event-structure .journey-stage-number {font-size:30px;font-weight:500;}



@media(max-width:700px){



 .welcome-simple,.host-event-structure,.host-tribe-slide,.host-role-slide {



  --training-heading-size:clamp(27px,6.6vw,36px);--training-hero-size:clamp(32px,8.4vw,46px);



 }



 .host-event-structure .event-flow-scene {min-height:540px;}



 .welcome-simple .welcome-simple-caption,.host-event-structure .event-flow-opening-copy,.definition-caption h1,.tribe-concept-intro h1,.host-role-slide .role-heading {font-size:clamp(28px,7.6vw,38px);}



 .welcome-simple .welcome-simple-roadmap h1,.difference-field-title,.host-event-structure .event-flow-heading,.host-role-slide .is-open .role-heading {font-size:clamp(23px,5.8vw,29px);}



 .host-event-structure .event-flow-heading {top:28px;}



 .host-event-structure .journey-diagrams {max-width:460px;margin-top:112px;}



 .welcome-simple .welcome-simple-grid p,.difference-field-item p {font-size:14px;}



 .difference-field-items {margin-top:40px;}



 .host-role-slide .role-column-heading h2 {font-size:clamp(16px,4vw,19px);}



 .host-role-slide .role-table-cell p {font-size:clamp(16px,4vw,19px);}



}



`;







const HEADLINE_FONT_IMPORT = "@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@700&display=swap');";



const HEADLINE_FONT_STYLES = `



.welcome-simple h1,



.welcome-simple .welcome-simple-caption,



.welcome-simple .welcome-simple-roadmap h1.welcome-roadmap-heading,



.host-tribe-slide h1,



.host-tribe-slide .difference-field-title,



.host-event-structure .event-flow-heading,



.host-event-structure .event-flow-opening-copy,



.host-role-slide .role-heading {



 font-family:'Merriweather',Georgia,'Times New Roman',serif;



 font-weight:700;font-style:normal;letter-spacing:-.015em;



}



.welcome-simple h1 .training-handwritten,



.welcome-simple .welcome-roadmap-heading .training-handwritten,



.host-tribe-slide h1 .training-handwritten,



.host-role-slide h1 .training-handwritten,



.host-event-structure h1 .training-handwritten {



 font-family:inherit;font-weight:inherit;font-size:inherit;line-height:inherit;



 font-style:normal;letter-spacing:inherit;transform:none;



}



`;





const EDITORIAL_STYLES = `

.host-role-slide .role-table.role-editorial-grid {

  display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:48px;

  width:calc(100% - 80px);max-width:1080px;margin-top:124px;margin-bottom:40px;

}

.host-role-slide .role-table.role-editorial-grid::after {

  content:'';position:absolute;top:68px;bottom:0;left:50%;width:1px;background:#e3e3e3;

}

 .host-role-slide .role-kinetic-slide .role-heading {white-space:nowrap;}

.host-role-slide .role-responsibility .role-column-heading h2 {white-space:nowrap;}

.host-role-slide .role-responsibility {min-width:0;margin:0;padding:0;background:transparent;border:0;}

.host-role-slide .role-responsibility .role-column-heading {

  display:flex;align-items:center;justify-content:center;gap:12px;

  width:fit-content;max-width:100%;min-height:36px;margin:0 auto 36px;padding:10px 16px;

  border:0;border-radius:6px;background:#f3f3f3;transition:opacity 280ms ease;

}

.host-role-slide .role-responsibility .role-column-heading::after {display:none;}

.host-role-slide .role-group-number {

  display:block;flex:0 0 auto;padding-right:12px;border-right:1px solid #d8d8d8;

  color:#666;font-size:11px;font-weight:600;line-height:1.6;font-variant-numeric:tabular-nums;

}

.host-role-slide .role-responsibility .role-column-heading h2 {

  margin:0;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;

  font-size:14px;font-weight:550;line-height:1.4;letter-spacing:-.01em;

}

.host-role-slide .role-responsibility .role-column-heading.is-muted {opacity:.38;}

.host-role-slide .is-reviewing .role-responsibility .role-column-heading {opacity:1;}

.host-role-slide .role-points {display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:32px;}

.host-role-slide .role-point {min-width:0;text-align:center;opacity:.2;transition:opacity 280ms ease;}

.host-role-slide .role-point.is-visible {opacity:.38;}

.host-role-slide .role-point.is-current,

.host-role-slide .is-reviewing .role-point.is-visible {opacity:1;}

.host-role-slide .role-point-marker {display:flex;flex-direction:column;align-items:center;margin:0 0 22px;}

.host-role-slide .role-point-number {

  position:relative;display:flex;align-items:center;justify-content:center;

  width:88px;height:88px;border:1.3px solid #111;border-radius:50%;background:transparent;color:#111;

}

.host-role-slide .role-point-digit {

  position:absolute;top:-5px;right:-5px;display:grid;place-items:center;

  width:26px;height:26px;border:0px solid #d6d6d6;border-radius:50%;background:#ededed;color:#111;

  font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;

  font-size:11px;font-weight:600;line-height:1;font-variant-numeric:tabular-nums;

}

.host-role-slide .role-point-icon {display:block;width:34px;height:34px;fill:none;}

.host-role-slide .role-point-stem {width:1px;height:31px;background:#111;}

.host-role-slide .role-point-dot {width:5px;height:5px;border-radius:50%;background:#111;}

.host-role-slide .role-point-copy {visibility:hidden;}

.host-role-slide .role-point.is-visible .role-point-copy {visibility:visible;}

.host-role-slide .role-point h3 {

  min-height:0;margin:0 0 12px;color:#111;white-space:nowrap;

  font-family:'Merriweather',Georgia,'Times New Roman',serif;

  font-size:18px;font-weight:700;line-height:1.45;letter-spacing:-.015em;

}

.host-role-slide .role-point p {

  max-width:230px;margin:0 auto;color:#656565;

  font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;

  font-size:14px;font-weight:400;line-height:1.65;letter-spacing:-.012em;

}

@media(min-width:701px) and (max-width:900px){

  .host-role-slide .role-table.role-editorial-grid {width:calc(100% - 48px);gap:32px;}

  .host-role-slide .role-points {gap:20px;}

  .host-role-slide .role-point h3 {font-size:15px;min-height:0;}

  .host-role-slide .role-point p {font-size:13px;}

}

@media(max-width:700px){

  .host-role-slide .role-table.role-editorial-grid {

    grid-template-columns:1fr;width:calc(100% - 40px);max-width:460px;

    gap:44px;margin-top:116px;margin-bottom:32px;

  }

  .host-role-slide .role-table.role-editorial-grid::after {display:none;}

  .host-role-slide .role-responsibility:first-child {padding-bottom:32px;border-bottom:1px solid #e3e3e3;}

  .host-role-slide .role-responsibility .role-column-heading {margin-bottom:28px;}

  .host-role-slide .role-points {gap:24px;}

  .host-role-slide .role-point-number {width:76px;height:76px;}

  .host-role-slide .role-point-digit {width:24px;height:24px;font-size:10px;}

  .host-role-slide .role-point-icon {width:30px;height:30px;}

  .host-role-slide .role-point-stem {height:26px;}

  .host-role-slide .role-point-marker {margin-bottom:20px;}

  .host-role-slide .role-point h3 {min-height:0;font-size:15px;line-height:1.5;}

  .host-role-slide .role-point p {font-size:13px;line-height:1.65;}

}

@media(max-width:360px){

  .host-role-slide .role-point h3 {font-size:13px;}

  .host-role-slide .role-responsibility .role-column-heading h2 {font-size:13px;}

}

@media(max-width:700px){

  .host-role-slide .role-kinetic-slide .role-heading {font-size:clamp(22px,5.8vw,32px);}

}

@media(prefers-reduced-motion:reduce){

  .host-role-slide .role-point,.host-role-slide .role-column-heading {transition:none;}

}

.host-role-slide .is-seeking .role-point,.host-role-slide .is-seeking .role-column-heading {transition:none;}

`;
